import React from 'react';
import { RoomAudioRenderer, RoomContext } from '@livekit/components-react';
import { ConversationProps } from './types';
import { useSupervisorSession } from './hooks';
import { ConversationContent, SupervisorBar } from './components';

export const MonitorConversationListV2: React.FC<ConversationProps> = ({
  phoneNumber = 'You',
  startCallTime,
  call,
  onError,
}: ConversationProps) => {
  const session = useSupervisorSession(call.id, call.status, onError);

  return (
    <RoomContext.Provider value={session.room}>
      {session.isJoined && <RoomAudioRenderer />}

      <SupervisorBar session={session} canJoin={call.status === 'in-progress'} />

      <ConversationContent
        call={call}
        phoneNumber={phoneNumber}
        startCallTime={startCallTime}
        onError={onError}
        isRoomConnected={session.isRoomConnected}
      />
    </RoomContext.Provider>
  );
};
